import { createFileRoute } from "@tanstack/react-router";

import { financialExplorerSearchSchema } from "@/features/financial-explorer/lib/explorer-search";

export const Route = createFileRoute(
  "/_protected/fas/projects/$id/_project-tabs/financial-explorer",
)({
  validateSearch: financialExplorerSearchSchema,
});
